import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 20v-16l-5 5","key":"svg-0"}]]

const IconNumber1 = createReactComponent('outline', 'number-1', 'Number1', __iconNode);

export default IconNumber1;